export default "__VITE_ASSET__Txb3VEf8__"